import React from "react";

const SignupLeft: React.FC = () => {
    return (
        <div className="text-white lg:flex flex-col signup-left w-[45%] justify-end p-6 hidden">
            <h1>Great choice !</h1>
            <span>Thanks for choosing to join Murwiza. <br />
                Create your account to starting  booking beautiful <br />
                hotels in Rwanda.
            </span>
        </div>
    )
}
export default SignupLeft;